import React, { useState } from "react";
import "./BlackFriday.css";
import logoLipe from "../Assets/logo_lipe.png";

// Link e Cupom oficiais enviados pelo cliente
const CHECKOUT_URL = "https://go.primecoaching.com.br/c/vAxf8w2tcx";
const CUPOM = "BLACK2026";

export default function BlackFriday() {
  const [copiado, setCopiado] = useState(false);
  
  const cupomDisponivel = Boolean(CUPOM);
  const checkoutDisponivel = Boolean(CHECKOUT_URL);

  const handleCopiar = () => {
    navigator.clipboard?.writeText(CUPOM);
    setCopiado(true);
    setTimeout(() => setCopiado(false), 2000);
  };

  return (
    <section id="black-friday" className="bf-strip" aria-labelledby="bf-title">
      <div className="bf-inner">
        <span className="bf-badge">Black November • Novembro</span>

        <h2 id="bf-title" className="bf-title">
          Oferta de Black Friday
        </h2>

        <p className="bf-sub">
          Apenas nesse mês de novembro! Garanta sua vaga com condição especial. Use o cupom no checkout.
        </p>

        {cupomDisponivel && (
          <div className="bf-cupom-wrap">
            <div className="bf-cupom-info">
              <span className="bf-cupom-label">Cupom</span>
              <code className="bf-cupom">{CUPOM}</code>
            </div>
            
            <button
              type="button"
              className={`bf-copy ${copiado ? "bf-copy--done" : ""}`}
              onClick={handleCopiar}
              aria-label="Copiar cupom"
            >
              {copiado ? "Copiado!" : "Copiar"}
            </button>
          </div>
        )}

        <a
          href={checkoutDisponivel ? CHECKOUT_URL : "#black-friday"}
          className="bf-cta"
        >
          Garantir minha vaga com desconto
        </a>

        <div className="bf-logos">
          <img src={logoLipe} alt="Lipe Consultoria" className="bf-logo" />
        </div>

        <p className="bf-disclaimer">*Válido somente até o esgotamento das vagas</p>
      </div>
    </section>
  );
}